import { render, staticRenderFns } from "./KnowledgeBaseTheory.vue?vue&type=template&id=8ce04338"
import script from "./KnowledgeBaseTheory.vue?vue&type=script&lang=js"
export * from "./KnowledgeBaseTheory.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeBaseTheory.vue?vue&type=style&index=0&id=8ce04338&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports